"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var NewEntryCalendar_1 = require("./Modals/NewEntryCalendar");
var PrintEntriesModal_1 = require("./Modals/PrintEntriesModal");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var diaryEntriesActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/list");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var translate_1 = require("utils/translate");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var moment = require("moment-timezone");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        list: state.diaryentries.list,
        selected: state.diaryentries.list.selected
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    deleteEntry: function (diaryUuid, entryUuid) {
        return dispatch(diaryEntriesActions.deleteEntry(diaryUuid, entryUuid));
    },
    removeEntrySignatures: function (diaryUuid, entryUuid) {
        return dispatch(diaryEntriesActions.removeEntrySignatures(diaryUuid, entryUuid));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('DiaryEntriesViewTools'), (0, recompose_1.withState)('confirmDialogOpen', 'setConfirmDialogOpen', false), (0, recompose_1.withState)('confirmDialogType', 'setConfirmDialogType', 'NONE'), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.currentProject !== nextProps.currentProject ||
            this.props.currentWorksiteDiary !== nextProps.currentWorksiteDiary ||
            this.props.selected !== nextProps.selected ||
            this.props.confirmDialogOpen !== nextProps.confirmDialogOpen ||
            this.props.confirmDialogType !== nextProps.confirmDialogType ||
            this.props.list !== nextProps.list) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.Tools = enhance(function (props) {
    var _a = React.useState(false), show = _a[0], setShow = _a[1];
    var _b = React.useState(false), showPrintModal = _b[0], setShowPrintModal = _b[1];
    var _c = React.useState(), startDate = _c[0], setStartDate = _c[1];
    var _d = React.useState(), startDatePrint = _d[0], setStartDatePrint = _d[1];
    var _e = React.useState(), endDatePrint = _e[0], setEndDatePrint = _e[1];
    var openModal = function () { return setShow(true); };
    var closeModal = function () { return setShow(false); };
    var openPrintModal = function () { return setShowPrintModal(true); };
    var closePrintModal = function () { return setShowPrintModal(false); };
    var setDate = function (date) { return setStartDate(date); };
    var setStartDateForPrint = function (date) { return setStartDatePrint(date); };
    var setEndDateForPrint = function (date) { return setEndDatePrint(date); };
    var perm = props.currentProject && props.currentProject.perm
        ? props.currentProject.perm
        : 0x00;
    var worksiteDiaryPerm = props.currentWorksiteDiary
        ? props.currentWorksiteDiary.perm
        : 0x00;
    var _f = React.useState(true), deleteButtonDisabled = _f[0], setDeleteButtonDisabled = _f[1];
    var _g = React.useState(true), removeSignaturesButtonDisabled = _g[0], setRemoveSignaturesButtonDisabled = _g[1];
    var getSelectedEntriesDates = function () {
        var selectedEntriesDates = props.selected.map(function (entry) {
            var item = props.list.list.find(function (x) { return x.entry_uuid === entry; });
            if (item && item.diary_date) {
                return parseInt(item.diary_date.toString(), 10);
            }
            return 0;
        });
        if (selectedEntriesDates.length === 0)
            return [];
        var filteredSelectedEntries = selectedEntriesDates.filter(function (y) { return y !== 0; });
        return filteredSelectedEntries.sort(function (a, b) { return a - b; });
    };
    var setInitalDates = function () {
        if (props.list.list && props.list.list.length !== 0) {
            var entries = props.list.list.map(function (entry) {
                var date = entry.diary_date.toString();
                return parseInt(date, 10);
            });
            setStartDateForPrint(moment(Math.min.apply(Math, entries)).toDate());
            setEndDateForPrint(moment(Math.max.apply(Math, entries)).toDate());
        }
    };
    React.useLayoutEffect(function () {
        var bool = true;
        if (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
            acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT)) {
            // Button enabled for master and Super admin by default
            bool = false;
            props.selected.map(function (entry) {
                var item = props.list.list.find(function (x) { return x.entry_uuid === entry; });
                // Disable delete button if any entry is signed by master
                if (item && item.master_signature !== '')
                    bool = true;
            });
        }
        setDeleteButtonDisabled(bool);
    }, [props.selected]);
    React.useLayoutEffect(function () {
        var bool = true;
        if (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT)) {
            // Remove signatures button enabled for Super admin if any of selected entries is signed
            props.selected.map(function (entry) {
                var item = props.list.list.find(function (x) { return x.entry_uuid === entry; });
                // Disable delete button if any entry is not signed by master
                if (item &&
                    (item.master_signature !== '' || item.supervisor_signature !== ''))
                    bool = false;
            });
        }
        setRemoveSignaturesButtonDisabled(bool);
    }, [props.selected]);
    React.useEffect(function () {
        var selectedEntries = getSelectedEntriesDates();
        var sDate = moment(selectedEntries[0]).toDate();
        var eDate = moment(selectedEntries[selectedEntries.length - 1]).toDate();
        setStartDateForPrint(sDate);
        setEndDateForPrint(eDate);
        if (selectedEntries.length == 0) {
            setInitalDates();
        }
    }, [props.selected]);
    React.useEffect(function () {
        try {
            setInitalDates();
        }
        catch (err) {
            setStartDateForPrint(moment().toDate());
            setEndDateForPrint(moment().toDate());
        }
    }, [props.list.list, props.list.list[0]]);
    return (React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'diaryentries-view-tools-container' },
        React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.confirmDialogOpen, close: function () { return props.setConfirmDialogOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                React.createElement(ConfirmDialog_1.Exclamation, null),
                React.createElement("div", null,
                    React.createElement("div", { className: 'title please-confirm-text' },
                        React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)(props.confirmDialogType === 'DELETE_ENTRY_CONFIRM'
                            ? 'diaryEntryView/diaryEntryViewDeleteEntry/pleaseConfirmDeletingEntries'
                            : 'diaryEntryView/diaryEntryViewDeleteEntry/pleaseConfirmRemovingSignatures'))),
                    React.createElement("div", { className: 'text' },
                        React.createElement("p", null, (0, translation_1.getLocalization)(props.confirmDialogType === 'DELETE_ENTRY_CONFIRM'
                            ? 'diaryEntryView/diaryEntryViewDeleteEntry/deletingEntriesNoticeText'
                            : 'diaryEntryView/diaryEntryViewDeleteEntry/removingSignaturesNoticeText'))))), footer: React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                        if (props.selected && props.selected.length) {
                            if (props.confirmDialogType === 'DELETE_ENTRY_CONFIRM') {
                                props.selected.map(function (entryUuid) {
                                    return props.deleteEntry(props.currentWorksiteDiary.diary_uuid, entryUuid);
                                });
                            }
                            else if (props.confirmDialogType === 'REMOVE_SIGNATURES_CONFIRM') {
                                props.selected.map(function (entryUuid) {
                                    return props.removeEntrySignatures(props.currentWorksiteDiary.diary_uuid, entryUuid);
                                });
                            }
                        }
                        props.setConfirmDialogOpen(false);
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setConfirmDialogOpen(false); } })) }),
        React.createElement(sok_ui_1.ToolsSidebar, { className: 'diaryEntriesView/tools', headerText: (0, translation_1.getLocalization)('diaryEntriesView/tools/header') },
            acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT) ? (React.createElement(sok_ui_1.ToolButton, { color: 'green', text: (0, translation_1.getLocalization)('diaryEntriesView/tools/createNew'), onClick: function () {
                    setStartDate(moment().toDate());
                    openModal();
                }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }) })) : null,
            React.createElement(sok_ui_1.ToolButton, { color: 'gray', text: (0, translation_1.getLocalization)('diaryEntriesView/tools/printDailyEntries'), onClick: function () { return openPrintModal(); }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-print' }) }),
            props.selected &&
                props.selected.length > 0 &&
                (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                    acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT)) && (React.createElement(sok_ui_1.ToolButton, { color: 'red', text: (0, translation_1.getLocalization)('diaryEntriesView/tools/deleteEntry'), onClick: function () {
                    if (props.selected && props.selected.length) {
                        props.setConfirmDialogOpen(true);
                        props.setConfirmDialogType('DELETE_ENTRY_CONFIRM');
                    }
                }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-trash' }), disabled: deleteButtonDisabled })),
            props.selected &&
                props.selected.length > 0 &&
                (acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                    acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT)) && (React.createElement(sok_ui_1.ToolButton, { color: 'gray', text: (0, translation_1.getLocalization)('diaryEntriesView/tools/removeSignatures'), onClick: function () {
                    if (props.selected && props.selected.length) {
                        props.setConfirmDialogOpen(true);
                        props.setConfirmDialogType('REMOVE_SIGNATURES_CONFIRM');
                    }
                }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-eraser' }), disabled: removeSignaturesButtonDisabled }))),
        startDate && (React.createElement(NewEntryCalendar_1.default, __assign({ closeModal: closeModal, show: show, startDate: startDate, setStartDate: setDate }, props))),
        React.createElement(PrintEntriesModal_1.default, __assign({ closeModal: closePrintModal, show: showPrintModal, startDate: startDatePrint, setStartDate: setStartDateForPrint, endDate: endDatePrint, setEndDate: setEndDateForPrint }, props))));
});
